import React from "react";

const BookingIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      {...props}
      xmlns="http://www.w3.org/2000/svg">
      <path d="M16.0002 20.9167C11.2431 20.9167 7.37061 17.1211 7.37061 12.4583C7.37061 7.79564 11.2431 4 16.0002 4C20.7573 4 24.6298 7.79564 24.6298 12.4583C24.6298 17.1211 20.7573 20.9167 16.0002 20.9167ZM16.0002 5.11038C11.866 5.11038 8.49895 8.40613 8.49895 12.4628C8.49895 16.5194 11.8614 19.8152 16.0002 19.8152C20.139 19.8152 23.5015 16.5194 23.5015 12.4628C23.5015 8.40613 20.139 5.11038 16.0002 5.11038Z" />
      <path d="M17.2687 12.4583L16.005 11.8655L14.7412 12.4583C14.7412 12.4583 15.4769 7.43729 15.6304 7.10551C15.7838 6.77372 16.0005 6.79584 16.0005 6.79584C16.0005 6.79584 16.2216 6.77372 16.3751 7.10551C16.5285 7.44172 17.2642 12.4583 17.2642 12.4583H17.2687Z" />
      <path
        d="M19.7466 14.5111C19.7466 14.5111 19.6563 14.7102 19.2681 14.6704C18.9161 14.6306 16.2622 13.8299 15.7567 13.675H15.7477C15.7206 13.6662 15.6935 13.6573 15.6845 13.6573C15.1384 13.5202 14.7412 13.0336 14.7412 12.4585C14.7412 11.7728 15.3054 11.2154 16.005 11.2154C16.3435 11.2154 16.6504 11.3481 16.876 11.556C16.8851 11.5649 16.8896 11.5693 16.8986 11.5781C17.1423 11.7861 19.4081 13.7458 19.6337 14.0334C19.8684 14.3342 19.7466 14.5111 19.7466 14.5111Z"
        fill="#57CC99"
      />
      <path
        d="M19.4481 22.5845C19.4481 22.5845 18.7395 22.7393 18.076 23.2879C17.4893 23.7656 17.1237 24.3231 17.0018 25.0707C16.9341 25.5263 16.6633 27.3 16.6633 27.3H15.3364C15.3364 27.3 15.0701 25.5308 14.9979 25.0707C14.8806 24.3186 14.515 23.7612 13.9282 23.2879C13.2602 22.7393 12.5562 22.5845 12.5562 22.5845L12.9217 21.5405C13.8876 21.8546 14.9257 22.0271 15.9999 22.0271C17.0741 22.0271 18.1121 21.859 19.0825 21.5405L19.4481 22.5845Z"
        fill="#57CC99"
      />
    </svg>
  );
};

export default BookingIcon;
